const initialState = {
    processName: "",
    className: [],
    limit: 20,
    current: 0,
    total: 0,
    imageId: [],
  };
  
  const processDataReducer = (state = initialState, action: any) => {
    switch (action.type) {
      case "SET_PROCESS_DATA":
        return { ...state, ...action.payload };
      default:
        return state;
    }
  };
  
  export default processDataReducer;
  